import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GaleriaService } from '../../../services/galeria.service';
import { Router } from '@angular/router';
import { ClienteConsola } from './../../../../../_entities/consola/cliente-consola';

@Component({
	selector: 'kt-clientes',
	templateUrl: './clientes.component.html',
	styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {
	public clientes: ClienteConsola[];
	public datosReporte = []
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public showNavigationButtons: boolean;
	public showPageSizeSelector: boolean;
	public mensajeAgrupar: string = "Arrastre un encabezado de columna aquí para agrupar por esa columna"

	constructor(private galeriaService: GaleriaService,
		private toastService: ToastrService,
		private router: Router) {
			this.showFilterRow = true;
			this.showHeaderFilter = true;
			this.showNavigationButtons = true;
			this.showPageSizeSelector = true;
		}

	ngOnInit() {
		this.obtenerClientes();
	}

	obtenerClientes() {
		this.galeriaService.obtenerClientes().subscribe(
			(clientes: ClienteConsola[]) => {
				this.clientes = clientes;
				this.clientes.forEach(cliente => {
					this.datosReporte.push({
						'ID': cliente.id,
						'Nombre': cliente.nombre
					});
				});
			}, (err) => {
				this.toastService.error('ocurrio un error al obtener los clientes');
			}
		);
	}

	verGaleria(idCliente) {
		this.router.navigateByUrl('/home/administracion/consola/clientes/galeria-vehiculos/' + idCliente)
	}

	regresar(){
		this.router.navigateByUrl('/home/administracion/consola/alertados') ///home/administracion/consola/clientes
	}


}
